import { createAction } from 'typesafe-actions';

export const downloadProductImages = createAction('documents/ORDER_PRODUCT_IMAGES_REQUEST')<{
  orderId: string;
  orderNumber: string;
}>();

export const downloadProductImagesSuccess = createAction('documents/ORDER_PRODUCT_IMAGES_SUCCESS')();

export const downloadProductImagesFailure = createAction('documents/ORDER_PRODUCT_IMAGES_FAILURE')();
